import React, { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  Box,
  Chip,
  Container,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  EmojiEvents as TrophyIcon,
  AccountBalanceWallet as WalletIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import ContestWinnersPage from './ContestWinnersPage';
import WalletWithdrawalsPanel from './WalletWithdrawalsPanel';
import { routes } from '../config/environment';

type PayoutTab = 'winners' | 'withdrawals';

const PayoutsCenterPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab: PayoutTab = useMemo(() => {
    const tab = searchParams.get('tab');
    return tab === 'withdrawals' ? 'withdrawals' : 'winners';
  }, [searchParams]);

  const handleTabChange = (_: React.SyntheticEvent, value: PayoutTab) => {
    setSearchParams(value === 'winners' ? {} : { tab: value });
  };

  return (
    <Container className="napc-page" maxWidth="lg" sx={{ py: { xs: 3, md: 6 }, minHeight: '100vh' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, gap: 2, flexDirection: { xs: 'column', md: 'row' }, mb: 2 }}>
        <Box>
          <Box className="napc-eyebrow">Payout Management</Box>
          <Typography variant="h4" component="h1" fontWeight="bold" sx={{ mb: 0.5 }}>
            Payouts Center
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Credit contest prizes to wallets and process user withdrawal requests in one place.
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip
            icon={<SettingsIcon />}
            label="Platform settings"
            onClick={() => navigate(routes.platformSettings)}
            color="primary"
            variant="outlined"
            clickable
          />
          <Chip icon={<ArrowBackIcon />} label="Back" onClick={() => navigate(-1)} color="primary" clickable />
        </Box>
      </Box>

      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab icon={<TrophyIcon />} iconPosition="start" label="Contest winners" value="winners" />
        <Tab icon={<WalletIcon />} iconPosition="start" label="Wallet withdrawals" value="withdrawals" />
      </Tabs>

      {activeTab === 'winners' ? (
        <ContestWinnersPage embedded />
      ) : (
        <WalletWithdrawalsPanel />
      )}
    </Container>
  );
};

export default PayoutsCenterPage;
